// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getLaborAdditivePipsSummary} from '../../pip/shared/repositories';

export const readLaborAdditiveSummaries = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborAdditivePipsSummary();

            dispatch({
                data,
                type: actions.READ_HOME_PAGE_LABOR_ADDITIVE_SUMMARY
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/labor-additive-summaries.js